import { buildTestIds } from "application";
import { Dispatch, SetStateAction, memo } from "react";
import { theme, Title } from "ui";
import { MenuTypes } from "typing";
import { Link } from "../../../../../../../Link";
import { companyProducts } from "../../data";
import {
  CategoryExploreIcon,
  CategorySidebarMenu,
  ListContentSidebarMenuWrapper,
  TitleWrapper,
} from "../../styles";

interface ServicesListProps {
  onCloseSidebarMenu: () => void;
  setCategoriesLevel: Dispatch<SetStateAction<MenuTypes>>;
}

const ServicesList = memo(
  ({ onCloseSidebarMenu, setCategoriesLevel }: ServicesListProps) => {
    return (
      <>
        <TitleWrapper>
          <Title
            {...buildTestIds("title-store-and-services")}
            color={theme.colors.neutral["999"]}
            fontSize={theme.typography.fontSize.sm.x5}
            fontWeight={theme.typography.fontWeight["500"]}
          >
            Serviços
          </Title>
        </TitleWrapper>

        {companyProducts?.map((products) => (
          <Link
            key={products.title}
            href={products.path}
            target="_selft"
            width="100%"
            {...buildTestIds(`highlight-categories-link-${products.title}`)}
          >
            <ListContentSidebarMenuWrapper
              {...buildTestIds(`list-content-wrapper-${products.title}`)}
              isBorderActive={false}
              isEnterpriseProduct
            >
              <CategorySidebarMenu
                {...buildTestIds(`${products.title}-sidebar-menu-mobile`)}
                isOffersList
                onClick={() => {
                  setCategoriesLevel("FirstLevel");
                  onCloseSidebarMenu();
                }}
              >
                {products.title}
              </CategorySidebarMenu>
              <CategoryExploreIcon {...buildTestIds("category-explore-icon")} />
            </ListContentSidebarMenuWrapper>
          </Link>
        ))}
      </>
    );
  }
);

ServicesList.displayName = "ServicesList";

export { ServicesList };
